import Vue from 'vue'

Vue.component('BaseLayout', () => import('./Base.vue'))
Vue.component('ErrorLayout', () => import('./Error.vue'))
